import {
  INTERACTION,
  ORANGE_LENS_TYPE,
  ORANGE_LENS_SHOPPABLE_IMAGES_HOTSPOTS,
  POST_PAGE_ERROR,
  ERROR
} from '../constants';
import { getOrangeLensProducts } from '../experience/pages/orangeLens/orangeLens.utils';

export const orangeLens = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('orange-lens.click-ris-drawer', ({ output }) => {
    const { category, eventName } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: category
      },
      eventInfo: {
        eventName
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('orange-lens.hotspot-click', ({ output }) => {
    const { categoryTitle, itemIds } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: ORANGE_LENS_SHOPPABLE_IMAGES_HOTSPOTS
      },
      orangelens: {
        section: categoryTitle
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);

    const parentBreadCrumbs = `${ORANGE_LENS_TYPE}>${categoryTitle} inspired by your image`;
    if (digitalData?.page?.pageInfo) {
      digitalData.page.pageInfo.pageName = parentBreadCrumbs;
    }
    digitalData.content = {
      ...digitalData.content,
      product: getOrangeLensProducts(itemIds)
    };
  });
  window.LIFE_CYCLE_EVENT_BUS.on('orange-lens.post-page-error', ({ output }) => {
    const {
      type,
      displayType,
      pageSection,
      message,
      code
    } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        POST_PAGE_ERROR,
        error: [
          {
            type,
            displayType,
            pageSection,
            message,
            code
          },
        ],
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });

};
